<template>
	<div>
		<div v-for="formElement in parent.formElements" v-bind:key="formElement.elementid">

			<div v-if="formElement.display">

				<!-- Bool button -->
				<div v-if="formElement.type == 'bool'" class="pb-2 pt-3">
					<button
						class="btn mr-2"
						v-bind:class="[
							formElement.cssclass,
							{
								'btn-on': formElement.value,
								'btn-off': !formElement.value,
								'requiredincomplete': formElement.requiredIncomplete
							}
						]"
						v-on:click="toggleSelection(formElement, true)"
						:disabled="!canEdit(formElement)"
					>
						{{ formElement.caption }}
					</button>
					<button class="btn btn-light btn-sm ml-1 btn-xs align-top" v-if="formElement.information" v-on:click="showInfo(formElement.caption , formElement.information)">
						<b-icon icon="question"></b-icon>
					</button>
				</div>

				<!-- Select buttons -->
				<div v-if="formElement.type == 'grade'" class="form-group clear-left">
					<label v-if="formElement.caption" class="mb-0">
						{{formElement.caption}}
						<button class="btn btn-light btn-sm ml-1 btn-xs mb-1" v-if="formElement.information" v-on:click="showInfo(formElement.caption , formElement.information)">
							<b-icon icon="question"></b-icon>
						</button>
					</label>
					<p v-if="formElement.subcaption" class="small mt-0 mb-0">{{formElement.subcaption}}</p>
					<div class="btn-group" style="display: block">
						<button
							v-for="item in formElement.values"
							v-bind:key="item.value"
							class="btn"
							v-bind:class="[
								item.cssclass ,
								{
									'btn-on': formElement.value == item.value,
									'btn-off': formElement.value != item.value,
									'requiredincomplete': formElement.requiredIncomplete
								}
							]"
							v-on:click="toggleSelection(formElement, item.value)"
							:disabled="!canEdit(formElement)"
						>
							{{ item.caption }}
						</button>
					</div>
				</div>

				<!-- Ok Not Ok buttons -->
				<div v-if="formElement.type == 'oknotok'" class="form-group clear-left">
					<label v-if="formElement.caption" class="mb-0">
						{{formElement.caption}}
						<button class="btn btn-light btn-sm ml-1 btn-xs mb-1" v-if="formElement.information" v-on:click="showInfo(formElement.caption , formElement.information)">
							<b-icon icon="question"></b-icon>
						</button>
					</label>
					<div class="btn-group" style="display: block">
						<button
							class="btn btn-on-good"
							v-bind:class="{
								'btn-on': formElement.value == 1,
								'btn-off': formElement.value != 1,
								'requiredincomplete': formElement.requiredIncomplete
							}"
							v-on:click="toggleSelection(formElement, 1)"
							:disabled="!canEdit(formElement)"
						>
							{{ $t('ok') }}
						</button>
						<button
							class="btn btn-on-bad"
							v-bind:class="{
								'btn-on': formElement.value == -1,
								'btn-off': formElement.value != -1,
								'requiredincomplete': formElement.requiredIncomplete
							}"
							v-on:click="toggleSelection(formElement, -1)"
							:disabled="!canEdit(formElement)"
						>
							{{ $t('not-ok') }}
						</button>
					</div>
				</div>

				<!-- Textarea -->
				<div v-if="formElement.type == 'textarea'" class="form-group clear-left">
					<label v-if="formElement.caption" class="mb-0">
						{{formElement.caption}}
						<button class="btn btn-light btn-sm ml-1 btn-xs mb-1" v-if="formElement.information" v-on:click="showInfo(formElement.caption , formElement.information)">
							<b-icon icon="question"></b-icon>
						</button>
					</label>
					<p v-if="formElement.subcaption" class="small mt-0 mb-0">{{formElement.subcaption}}</p>
					<textarea-autosize
						v-model="formElement.value"
						class="form-control"
						:class="{'requiredincomplete': formElement.requiredIncomplete }"
						:disabled="!canEdit(formElement)"
						:placeholder="formElement.placeholder"
					></textarea-autosize>
				</div>

			</div>

		</div>
	</div>
</template>

<script>
export default {
	name: "treatmentsessionformelements",
	props: {
		treatmentsession: Object,
		parent: Object,
		canMark: Boolean
	},
	data() {
		return {
		}
	},
	mounted() {

	},
	computed: {
		allowStudentFeedback: function(){
			if(!('id' in this.treatmentsession) || !this.treatmentsession.id){
				return true;
			}
			var secondsSinceTreatment = (Date.now() / 1000) - this.treatmentsession.treatmentTimestamp;
			var daysSinceTreatment = Math.floor(secondsSinceTreatment / (60 * 60 * 24));
			if(this.$config.getValue("lockstudentfeedbackdays")){
				if(daysSinceTreatment <= this.$config.getValue("lockstudentfeedbackdays")){
					return true;
				}
			} else {
				return true;
			}
			return false;
		}
	},
	methods: {
		canEdit(formElement) {
			if(this.treatmentsession.isLocked && formElement.id != 'studentFeedback'){
				return false;
			}
			if('studentinput' in formElement){
				if(formElement.studentinput == true){
					if(this.$UserSession.getValue("id") == this.treatmentsession.student){
						if(this.allowStudentFeedback){
							return true;
						} else {
							return false;
						}
					} else {
						return false;
					}
				}
			}
			if(formElement.id == 'studentFeedback'){
				if(this.$UserSession.getValue("id") == this.treatmentsession.student){
					if(this.allowStudentFeedback){
						return true;
					} else {
						return false;
					}
				} else {
					return false;
				}
			}
			return this.canMark;
		},
		toggleSelection(formElement, value) {
			if (formElement.value != value) {
				formElement.value = value;
			} else {
				formElement.value = false;
			}
		},
		showInfo: function(caption , information) {
			this.$store.commit("openDialog" , {
				cancelBtn: false ,
				title: caption,
				htmlContent: information,
				size: 'lg'
			});
		}
	},
};
</script>
